import { Link } from 'react-router-dom';
import './RelatedArticles.css';

function RelatedArticles({ articles = [] }) {
  if (articles.length === 0) return null;

  return (
    <div className="related-articles">
      <h3>Altri articoli che potrebbero interessarti</h3>
      <div className="related-grid">
        {articles.map(article => {
          const [day, month, year] = article.date.split('/').map(Number);
          const dateObj = new Date(year, month - 1, day);
          return (
            <Link
              key={article.id}
              to={`/articles/${article.id}`}
              className="related-article-card"
            >
              <div className="related-article-date">
                <span className="date-day">{dateObj.getDate()}</span>
                <span className="date-month">
                  {dateObj.toLocaleDateString('it-IT', { month: 'short' })}
                </span>
              </div>
              <div className="related-article-info">
                <h4>{article.title}</h4>
                <p className="related-date">
                  {dateObj.toLocaleDateString('it-IT', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default RelatedArticles;
